// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2s-1";
export var movingGradient = "_2s-4";
export var movingGradientBlock = "_2s-2";
export var skeleton = "_2s-0";
export var skeletonText = "_2s-3";